import API from "@utils/request";
import { PAGE_SIZE } from "@config";
import store from "../store";
const ADRESS = "/api/adminuserpending/";

/**
* 获取管理员提示小窗口列表（分页）
* @author 四川创企
* @DateTime 2026/03/13
* @param {object} params
* @param {object} pages
*/
export async function getAdminUserPendingList(params, pages) {
    try {
        return await API.get(ADRESS + "list", {
            params: {
            ...params,
            ...pages,
            },
            headers: { isLoading: true },
        });
    } catch (error) {
        return error;
    }
}



